import apiClient from '../connections/api'

export default {
    getAll: () => {
        return apiClient.get('/crons')
    },
    update: (name, data) => {
        return apiClient.patch(`/crons/${name}`, data)
    },
    run: (name) => {
        return apiClient.post(`/crons/${name}/run`)
    }
}
